import React, { useContext, useEffect, useState, useCallback } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function LiveRate({ symbol_id, buy_sell }) {
  const socket = useContext(SocketContext);

  const [Ask, setAsk] = useState(0);
  const [Bid, setBid] = useState(0);
  const [LTP, setLTP] = useState(0); // new LTP state

  const trade = useCallback((data) => {
    if (data) {
      setAsk(data.Ask || 0);
      setBid(data.Bid || 0);
      setLTP(data.LTP || 0);
    }
  }, []);

  useEffect(() => {
    if (!socket) return;

    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);

    return () => socket.off("trade" + symbol_id, trade);
  }, [socket, symbol_id, trade]);

  // -------------------------------
  // PRICE LOGIC
  // -------------------------------

  let displayPrice;

  if (buy_sell === 0) {
    // BUY SIDE → show BID, else fallback LTP
    displayPrice = Bid > 0 ? Bid : LTP;
  } else {
    // SELL SIDE → show ASK, else fallback LTP
    displayPrice = Ask > 0 ? Ask : LTP;
  }

  return (
    <div className="menuBuyPrice large">
      {parseFloat(displayPrice)}
    </div>
  );
}
